
export function showUpgradeModal(vueInstance) {
  vueInstance.cComponent = 'components/common/UpgradeConfirmationModal';
  vueInstance.modalWidth = '500px';
  vueInstance.modalwidth = '500px';
  vueInstance.status = true;
  vueInstance.alertBoxData = { persistent: false };
}


export function hasMasterPyqAccess(user) {
  const constants = require('@/utils/constants').default;
  
  const userDetails = user || JSON.parse(localStorage.getItem('user') || '{}');
  const subscriptionDetails = userDetails.subscription_details || [];
  
  let productId;
  if (userDetails.batch_name === '2026') {
    productId = (userDetails.center_name === 'JEE' || userDetails.center_name === 'Engineering')
      ? constants.MODULES.MASTERPYQJEE26
      : constants.MODULES.MASTERPYQNEET26;
  } else if (userDetails.batch_name === '2027') {
    productId = (userDetails.center_name === 'JEE' || userDetails.center_name === 'Engineering')
      ? constants.MODULES.MASTERPYQJEE27
      : constants.MODULES.MASTERPYQNEET27;
  } else if (userDetails.batch_name === '2028') {
    productId = (userDetails.center_name === 'JEE' || userDetails.center_name === 'Engineering')
      ? constants.MODULES.MASTERPYQJEE28
      : constants.MODULES.MASTERPYQNEET28;
  }
  
  return subscriptionDetails.some(sub => 
    sub.product_id && sub.product_id.includes(productId)
  );
}